import { Component, Input, OnInit } from '@angular/core';
import { IContextSetting, NetworkConstants, deepCopy, determineLocale, statusColorsLabSampleGR } from 'diwimamodelweb/lib';
import { GameRecordListItem } from '../model/list';
import { firstValueFrom, skipWhile, take } from 'rxjs';
import { SettingsService } from '../settings.service';
import { HuntingDistrictService } from '../hunting-district.service';

@Component({
  selector: 'app-gamerecord-list-item',
  templateUrl: './gamerecord-list-item.component.html',
  styleUrls: ['./gamerecord-list-item.component.css']
})
export class GamerecordListItemComponent implements OnInit {

  @Input() data: GameRecordListItem
  locale: string|undefined = undefined
  statusColorsLabSampleGR = statusColorsLabSampleGR
  statustitle:any
  hi_tier:any
  nvTrichinella:any
  settingsGRStatus:any = []
  settingsLabSamplesTypes:any = []
  backgroundColor:string = "#fbf8fb"
  allHDs = []

  constructor(private settingsService: SettingsService,
    private hdService: HuntingDistrictService) {
    this.locale = determineLocale(navigator.language)
  }

  async ngOnInit(): Promise<void> {
    this.allHDs = this.hdService.huntindDistrictSubject$.value
    const settingRef = NetworkConstants.SETTING_LAB_SAMPLE_TYPE
    const context = await firstValueFrom(this.settingsService.selectedUserContext$.pipe(
      skipWhile(el => !el),
      take(1)
    ))
    this.hi_tier = context.modulesMap?.get('hi-tier') ? true : false
    this.nvTrichinella = context.modulesMap?.get('nvTrichinella') ? true : false
    this.settingsLabSamplesTypes = context?.settingsMap.get(settingRef)?.values ?? []
    this.settingsGRStatus = (context?.settingsMap.get(NetworkConstants.SETTING_GR_STATUS) as IContextSetting).values ?? []
    this.statustitle = this.settingsGRStatus?.find(st =>  st.identifier === this.data.data.status)?.title
    this.getGRColor()
  }

  click() {
    this.data.onClick()
  }

  delete() {
    this.data.onDelete()
  }

  getLabTitle(lab){
    return this.settingsLabSamplesTypes?.find(type => lab.type === type.identifier)?.title
  }

  getLabColor(lab){
    // return this.statusColorsLabSampleGR.find( s => s.type === lab.state)?.color
    if(lab.examinations){
      if(lab.examinations.every(val => val.result === "negativ"))
      return "rgb(71 203 0 / 70%)"//"green"

      if(lab.examinations.every(val => val.result === "positiv"))
      return "rgba(255, 0, 0, 0.6)"//"red"

      if(lab.examinations.some(val => val.result === "positiv") && lab.examinations.some(val => val.result === "negativ"))
      return "rgba(255, 255, 0, 0.3)"//"yellow"

      if(lab.examinations.every( val => val.result != "negativ" && val.result != "positiv"))
      return "rgba(255, 255, 0, 0.3)"//"yellow"

    }else
      return "rgb(128 128 128 / 50%)"//"grey"
  }

  getGRColor(){
    const samples = deepCopy(this.data.data?.laboratorySamples ?? undefined)
    const rep: { [key: string]: number } = {};
    const wildart = this.data?.data?.wildart ?? ""

    if(!samples) {
      if(this.hi_tier || this.nvTrichinella) {
        if(wildart === "Schwarzwild" || wildart === "Dachs"){
          const hd = this.allHDs?.find(hd => hd.identifier === this.data.data.huntingDistrictId)
          if(hd?.nvTrichinellaActive || hd?.hiTierActive)
            this.backgroundColor = "#f009"
          // else
          //   this.backgroundColor = "#fbf8fb"//white
        }
      }
      return;
    }

    // samples.forEach(sample => {
    //   if(sample.nvState && !sample.hiTierState)
    //   rep[sample.nvState] = (rep[sample.nvState] ?? 0) + 1
    //   if(sample.hiTierState && !sample.nvState)
    //   rep[sample.hiTierState] = (rep[sample.hiTierState] ?? 0) + 1
    //   if(sample.hiTierState && sample.nvState && sample.hiTierState == sample.nvState)
    //   rep[sample.hiTierState] = (rep[sample.hiTierState] ?? 0) + 1
    //   if(sample.hiTierState && sample.nvState && sample.hiTierState != sample.nvState) {
    //     rep[sample.hiTierState] = (rep[sample.hiTierState] ?? 0) + 1
    //   }
    // });

    // let max = 0
    // let nvState = undefined
    // let maxPrio = Infinity

    // Object.keys(rep).forEach( state=> {
    //   const count = rep[state]
    //   const priority = this.statusColorsLabSampleGR.find( s => s.type === state)?.sort ?? Infinity;
    //   if( count > max || (count === max && priority < maxPrio)){
    //     max = rep[state]
    //     nvState = state
    //     maxPrio = priority
    //   }
    // })
    // this.backgroundColor = this.statusColorsLabSampleGR.find( s => s.type === nvState)?.color

    const allstates = [...new Set( samples.flatMap(i => [i.nvState, i.hiTierState]) )];

    if (allstates?.includes('skippedSubmission' ) || allstates?.includes('submissionFailed') 
      || allstates?.includes('certificateFailed')
      || allstates?.includes('authenticationFailed') || allstates?.includes('sampleRejected')
    ) {
      this.backgroundColor = 'rgba(255, 0, 0, 0.6)'//red
      return;
    }
     
    if (allstates?.includes('pendingSubmission'  ) || allstates?.includes('pendingResults' ) || allstates?.includes('pendingResult' ) || allstates?.includes('certificatePending' )) {
      this.backgroundColor = 'rgba(255,255,0,0.3)' //yellow
    }

  }

}
